/**
 * NON_PATIENT_FACING: econsentEditor|econsentGenerate|econsentPreview|econsentPdfEditor|econsentPdfPreview
 */
export default {
  "avatar.firstInitialLastInitial": "{firstInitial}{lastInitial}",
  "userPopup.name": "{firstName} {lastName}",
  "accountSettings.loggedOut": "Logged Out",
  "accountSettings.loggedOutWhileInactive":
    "We logged you out while you were inactive. Please select OK to log in again.",
  "alertModal.ok": "OK",
  "authenticatedRoute.updatesToAppPolicies": "Updates to App Policies",
  "authenticatedRoute.updatedTermsMessage":
    "We've made updates to our Privacy Notice and/or Terms of Service. The current versions of these documents are linked below.",
  "authenticatedRoute.privacyNotice": "Privacy Notice",
  "authenticatedRoute.returnToLogin": "Return to Login",
  "confirmNewNumber.confirmPhoneNumberText": "Confirm Phone Number – Text",
  "confirmNewNumber.confirmPhoneNumberVoice":
    "Confirm Phone Number – Voice Call",
  "confirmNewNumber.enterMfaDescription":
    "We sent a six-digit verification code to: <br></br> <span><b>{digits}</b></span>.",
  "confirmNewNumber.enterMfaDescriptionCall":
    "We're calling <span><b>{digits}</b></span> to give you a six-digit verification code.",
  "confirmNewNumber.linkExpired": "Link Expired",
  "confirmNewNumber.login": "log in",
  "confirmNewNumber.loginToRequestNewPhoneNumber":
    "Please {linkToLoginPage} and request a new link to change your phone number.",
  "confirmIdentity.heading": "Confirm Identity",
  "confirmIdentity.info":
    "Select the contact method that you want to use to verify your identity. If the contact information is incorrect, contact your study team.",
  "confirmIdentity.email.heading": "Confirm Identity – Email",
  "confirmIdentity.email.info":
    "We sent an email to <span>{email}</span> with a link that will allow you to log in.",
  "confirmIdentity.email.sendAnotherEmail": "Send Another Email",
  "confirmIdentity.email.failedToSend": "Failed to Send",
  "confirmIdentity.email.modalInfo":
    "Your email has failed to send. Please check your internet, and return to the login page to try again.",
  "confirmIdentity.email.ok": "OK",
  "confirmIdentity.text": "Text",
  "confirmIdentity.email": "Email",
  "confirmIdentity.call": "Call",
  "confirmIdentity.next": "Next",
  "identityConfirmed.mainText": "Identity Confirmed",
  "identityConfirmed.linkExpired.heading": "Link Expired",
  "identityConfirmed.linkExpired.info":
    "This email confirmation link is expired. Please make sure you're using the most recent confirmation email, or use another verification method.",
  "determineUser.notEnoughInformationTitle": "Not Enough Information on File",
  "determineUser.notEnoughInformationMessage":
    "To register without an activation code, you need an email and phone number on file. Your study team can add this info for you or give you a code.",
  "determineUser.ok": "OK",
  "determineUser.somethingWentWrong": "Something Went Wrong",
  "determineUser.pleaseReturnToLogin":
    "Please return to the login page and try again.",
  "determineUser.returnToLogin": "Return to Login",
  "documents.version": "Version",
  "econsentPdfEditor.goBack": "Go Back",
  "econsentPdfEditor.errorTitle.save": "{econsent} Requires Signature to Save",
  "econsentPdfEditor.warningTitle.save": "Save {econsent}?",
  "econsentPdfEditor.errorTitle.preview":
    "{econsent} Requires Signature to Preview",
  "econsentPdfEditor.missingRequiredSignatures":
    "Your document is missing required signatures and cannot be saved until these are added.",
  "econsentPdfEditor.pleaseAddTheFollowingMissingSignatures":
    "Please add the following missing signatures to continue:",
  "econsentPdfEditor.forAFullyCompleteEconsentAdd":
    "For a fully complete {econsent}, consider also adding:",
  "econsentPdfEditor.validation.missingSignatures":
    "A required signature for the following role(s): {roles}",
  "econsentPdfEditor.validation.missingSignatureBlockForParticipant":
    "A required signature for a participant or representative.",
  "econsentPdfEditor.validation.missingSiteSignature":
    "A signature for a site staff member.",
  "econsentPdfEditor.error.restrictedFormattingTitle":
    "The document could not be saved.",
  "econsentPdfEditor.error.restrictedFormattingMessage":
    "There are unsupported characters in the Patient Facing Title. Please remove any special characters and try again.",
  "econsentPdfEditor.restrictedFormatting":
    "There are unsupported characters in this label. Please remove special characters to continue.",
  "econsentPdfEditor.saveAndExit": "Save {ampersand} Exit",
  "econsentPdfEditor.save": "Save",
  "econsentPdfEditor.popupSavedToVaultVersion":
    "Version {majorVersion}.{minorVersion}",
  "econsentPdfEditor.savedToSiteVault": "{version} Saved to {sitevault}",
  "econsentPdfEditor.savingToSiteVault": "Saving to {sitevault}",
  "econsentPdfEditor.checkingInYourDocument":
    "Checking in the document. You'll be redirected to {sitevault} when the check-in is complete.",
  "econsentPdfEditor.redirectingToSiteVault":
    "Check-in complete. You're being redirected to {sitevault}.",
  "econsentPdfEditor.elementInstructions":
    "Drag and drop the elements below into the document to create your {econsent}.",
  "econsentPdfEditor.signatureElements": "Signature Elements",
  "econsentPdfEditor.signatureBlock": "Signature Block",
  "econsentPdfEditor.signature": "Signature",
  "econsentPdfEditor.printedName": "Printed Name",
  "econsentPdfEditor.signatureDate": "Signature Date",
  "econsentPdfEditor.responseElements": "Response Elements",
  "econsentPdfEditor.checkBox": "Checkbox",
  "econsentPdfEditor.radioButton": "Radio Button",
  "econsentPdfEditor.textEntry": "Text Entry",
  "econsentPdfEditor.previewEConsent": "Preview {econsent}",
  "econsentPdfEditor.documentSettings": "Document Settings",
  "econsentPdfEditor.currentElements": "Current Elements",
  "econsentPdfEditor.required": "Required",
  "econsentPdfEditor.optional": "Optional",
  "econsentPdfEditor.noElements": "No elements in your document",
  "econsentPdfEditor.noElementsMessage":
    "Drag-and-Drop from the left-hand side to get started.",
  "econsentPdfEditor.participantSignature": "Participant Signature",
  "econsentPdfEditor.cancel": "Cancel",
  "econsentPdfEditor.delete": "Delete",
  "econsentPdfEditor.addSignatureBlock": "Add Signature Block",
  "econsentPdfEditor.addSignatureBlockDescription":
    "Add your signature, name, and date—all in one step.",
  "econsentPdfEditor.makeThisSignatureRequired": "Make this signature required",
  "econsentPdfEditor.makeThisSignatureRequiredTooltip":
    "When required, this person must sign this part of the document for submission, but only if the document is sent to them.",
  "econsentPdfEditor.signatureLabel": "Signature Label",
  "econsentPdfEditor.signatureLabelTooltip":
    "Provide each signature with a unique label to easily report on and reference participant signatures.",
  "econsentPdfEditor.signatureLabelPlaceholder":
    "ex: Study Participation, Optional Consent",
  "econsentPdfEditor.dupliceSignatureLabelError":
    "The same signature label cannot be used twice.",
  "econsentPdfEditor.whichElementsDoYouWantToInclude":
    "Which Elements do you want to include?",
  "econsentPdfEditor.whichElementsDoYouWantToIncludeTooltip":
    "Select elements that align with the signature fields in the document.",
  "econsentPdfEditor.autoPopulated": "Auto-populated",
  "econsentPdfEditor.addSignatureElement": "Add Signature Element",
  "econsentPdfEditor.siteSignaturePlaceholder": "Site Signature Placeholder",
  "econsentPdfEditor.siteSignaturePlaceholderDescription":
    "This text will be applied to the site signature area after all {myveeva} users have signed.<br></br>This text will not be translated, please enter the appropriate translation for non-English consent forms.",
  "econsentPdfEditor.addPrintedNameElement": "Add Printed Name Element",
  "econsentPdfEditor.addSignatureDateElement": "Add Signature Date Element",
  "econsentPdfEditor.personSigning": "Person Signing",
  "econsentPdfEditor.personAnswering": "Person Answering",
  "econsentPdfEditor.addCheckbox": "Add Checkbox",
  "econsentPdfEditor.checkBoxDescription":
    "Each Checkbox will be an individual component",
  "econsentPdfEditor.addRadioButtonGroup": "Add Radio Button Group",
  "econsentPdfEditor.deleteRadioButtons": "Delete these Radio Buttons?",
  "econsentPdfEditor.radioButtonNumber": "Radio Button {optionNumber}",
  "econsentPdfEditor.invalidDuplicateAnswerLabel":
    "The same answer label cannot be used twice.",
  "econsentPdfEditor.answerLabel": "Answer Label",
  "econsentPdfEditor.answerLabelPlaceholder": "Add Answer Label",
  "econsentPdfEditor.questionLabel": "Question Label",
  "econsentPdfEditor.questionLabelPlaceholder": "Select or Make a New Label",
  "econsentPdfEditor.addQuestionLabel": "Add Question Label",
  "econsentPdfEditor.radioButtonDescription":
    "Each radio button group requires a minimum of two answers for respondents to choose from.",
  "econsentPdfEditor.requiredQuestionLabel": "Make this question required",
  "econsentPdfEditor.saveAndAddRadioButton": "Save + Add",
  "econsentPdfEditor.addNextRadioButton": "Add Next Button",
  "econsentPdfEditor.addTextEntry": "Add Text Entry",
  "econsentPdfEditor.textEntryDescription":
    "Each Text Entry field will be an individual component.",
  "econsentPdfEditor.previewLabel": "Preview Text",
  "econsentPdfEditor.previewLabelPlaceholder": "Text Placeholder",
  "econsentPdfEditor.previewLabelTooltip":
    "Preview Text will be displayed to the person answering this question to help them format their answer. For example: If a date is expected, enter the format you'd like them to use, i.e. MM/DD/YYYY or otherwise.",
  "econsentPdfEditor.roleSelectPlaceholder": "Please Select a Role",
  "econsentPdfEditor.role.participant": "Participant",
  "econsentPdfEditor.role.site": "Site",
  "econsentPdfEditor.role.siteMember": "Site Member",
  "econsentPdfEditor.role.caregiver": "Caregiver",
  "econsentPdfEditor.role.secondCaregiver": "Second Caregiver",
  "econsentPdfEditor.role.guardian": "Guardian",
  "econsentPdfEditor.role.secondGuardian": "Second Guardian",
  "econsentPdfEditor.role.proxy": "Proxy",
  "econsentPdfEditor.role.translator": "Translator",
  "econsentPdfEditor.role.witness": "Witness",
  "econsentPdfEditor.role.secondWitness": "Second Witness",
  "econsentPdfEditor.role.mainSigner": "Main Signer",
  "econsentPdfEditor.close": "Close",
  "econsentPdfEditor.displayName": "{myveeva} Display Name",
  "econsentPdfEditor.displayNameTooltip":
    "Provide this document with a unique label for easy participant recognition in the {myveevaforpatients} app.",
  "econsentPdfEditor.personSigningTooltip":
    "Select the role of the person expected to sign.",
  "econsentPdfEditor.siteSignaturePlaceholderTooltip":
    'Provide text to display in place of site signatures, which are appended to this document on a separate page. For example, "Signature applied via {sitevault} eSignature".',
  "econsentPdfEditor.personAnsweringTooltip":
    "Select the role of the person expected to respond. Choose Main Signer if a Proxy or Guardian may answer on behalf of a Participant.",
  "econsentPdfEditor.questionLabelTooltip":
    "Provide each question with a unique label to easily report on and reference participant responses.",
  "econsentPdfEditor.answerLabelTooltip":
    "Provide each answer with a unique label to easily report on and reference participant responses.",
  "econsentPdfEditor.signatureRequirements": "Signature Requirements",
  "econsentPdfEditor.requireUnlockCodeToSign": "Require an unlock code to sign",
  "econsentPdfEditor.requireUnlockCodeToSignTooltip":
    "Participants need a code to sign this document. Site staff will create the code in the preview opened from {sitevault} and provide it to them.",
  "econsentPdfEditor.requireHandDrawnSignature":
    "Require a hand drawn signature",
  "econsentPdfEditor.requireHandDrawnSignatureTooltip":
    "Participants will need to draw their signature on a device.",
  "econsentPdfEditor.signingOrder": "Signing Order",
  "econsentPdfEditor.signingOrderTooltip":
    "You can enter a Signing Order for this document if a participant needs to sign it before or after signing other documents. For example, a document with a Signing Order of 1 must be signed before a document with a Signing Order of 2.",
  "econsentPdfEditor.documentLanguageSettings": "Document Language Settings",
  "econsentPdfEditor.rightToLeftLanguage": "Right-To-Left Language",
  "econsentPdfEditor.rightToLeftLanguageTooltip":
    "Enabling Right to Left Language updates the form to correctly display the UI for languages that are written and read from right to left, such as Arabic and Hebrew. The alignment of text elements is adjusted accordingly.",
  "econsentPdfEditor.setDocumentToRTL": "Set Document to Right to Left",
  "econsentPdfEditor.setDocumentToLTR": "Set Document to Left to Right",
  "econsentPdfEditor.setDocumentToRTLDescription":
    "Enabling this setting mirrors UI elements to be displayed for right to left languages. Select Confirm to change the UI to be displayed from right to left.",
  "econsentPdfEditor.setDocumentToLTRDescription":
    "Disabling this setting mirrors UI elements to be displayed for left to right languages. Select Confirm to change the UI to be displayed from left to right.",
  "econsentPdfEditor.confirm": "Confirm",
  "econsentPdfEditor.backToSiteVault": "Back to {sitevault}",
  "econsentPdfEditor.versionComments": "Version Comments (Optional)",
  "econsentPdfEditor.descriptionModalMessageSave":
    "Save a new version of your {econsent} to {sitevault} and keep the document checked out, or Cancel to resume editing.",
  "econsentPdfEditor.descriptionModalMessageSaveExit":
    "Save a new version of your {econsent} to {sitevault} and end your editing session, or Cancel to resume editing.",
  "econsentPdfEditor.errorLoadingPreview": "Error Loading Preview",
  "econsentPdfEditor.error.couldnt-be-saved-title":
    "Your changes couldn't be saved",
  "econsentPdfEditor.error.couldnt-checkin-title":
    "Your changes couldn't be checked in",
  "econsentPdfEditor.error.saveEconsentByAuthor.403-checkin-message":
    "We couldn't check in the document because the document is no longer checked out to you. Please return to {sitevault} to check out the document and continue editing.",
  "econsentPdfEditor.error.saveEconsentByAuthor.403-message":
    "We couldn't save your changes to {sitevault} because the document is no longer checked out to you. Please return to {sitevault} to check out the document and continue editing.",
  "econsentPdfEditor.error.updateEConsentByAuthor.403-message":
    "We couldn't autosave your most recent changes because the document is no longer checked out to you. Please return to {sitevault} to check out the document and continue editing.",
  "econsentPdfEditor.error.saveEconsentByAuthor.503-checkin-message":
    "We couldn't check in your document to {sitevault} due to a connection error. Please reopen the editor from {sitevault} to automatically retry saving your changes.",
  "econsentPdfEditor.error.saveEconsentByAuthor.503-message":
    "We couldn't save your changes to {sitevault} due to a connection error. Please reopen the editor from {sitevault} to automatically retry saving your changes.",
  "econsentPdfEditor.error.session-expired-message":
    "Please log in through {sitevault} to continue editing.",
  "econsentPdfPreview.actionNotAvailableInPreview":
    "Action Not Available in Preview Mode",
  "econsentPdfPreview.submitUnavailable":
    "A study participant would be required to verify their identity with a code sent to their phone.",
  "econsentPdfPreview.declineEconsentUnavailable":
    "A study participant would be sent to the To Do tab.",
  "econsentPdfPreview.existingUnlockCodeBanner":
    "This document is ready to sign, but you need a code from the study site. Unlock code: {unlockCode}",
  "econsentPdfPreview.createUnlockCodeBanner":
    "This document is ready to sign, but you need a code from the study site. <Button>Create unlock code</Button>",
  "econsentPdfPreview.createUnlockCodeMessage":
    "Release this document for signature by sharing the unlock code with your participants or signatories.",
  "econsentPdfPreview.createUnlockCodeTitle": "Create Unlock Code",
  "econsentPdfPreview.codeWillExpire": "Code will expire in:",
  "econsentPdfPreview.createCodeButton": "Create Code",
  "econsentPdfPreview.cancel": "Cancel",
  "econsentPdfPreview.previewModalMessage":
    "You can perform actions such as signing, declining, and downloading the document, but your actions will not be saved.",
  "econsentPdfPreview.previewModalTitle": "This Document Is in Preview Mode",
  "econsentPdfPreview.previewDefaultName": "Signature Preview",
  "econsentPdfPreview.unlockCodeErrorMessage":
    "Sorry, we could not create the unlock code. Please refresh the page and try again.",
  "econsentPdfPreview.unlockCodeErrorTitle": "Your Code Could Not Be Created",
  "econsentPdfPreview.loginToSiteVault":
    "Log in through {sitevault} to view this preview.",
  "econsentPdfPreview.previewMode": "PREVIEW MODE",
  "econsentPdfPreview.generationInformationApprovedVersion":
    "{firstName} {lastName} generated this preview on {generatedDate}.",
  "econsentPdfPreview.generationInformationExpirationDate":
    "{firstName} {lastName} generated this preview on {generatedDate}. This link will expire on {expirationDate}.",
  "econsentPdfPreview.previewNotAvailable": "Preview No Longer Available",
  "econsentPdfPreview.previewRemovedMessage":
    "Sorry, this preview was removed by the study site.",
  "econsentPdfPreview.previewCouldntBeOpened": "Preview Couldn't Be Opened",
  "econsentPdfPreview.previewCouldntBeOpenedMessage":
    "Sorry, we weren't able to open the preview. Please refresh the page to try again.",
  "econsentPdfPreview.failedToOpenPreview":
    "Sorry, we weren't able to open the preview. Please refresh the page to try again, and contact the original link provider if you still can't access it.",
  "econsentPdfPreview.invalidLink": "Invalid Link",
  "econsentPdfPreview.invalidEditorPreviewLinkDescription":
    "Sorry, we don't have a preview at that address. Please return to the editor and open the preview from there.",
  "econsentPdfPreview.invalidGlobalPreviewLinkDescription":
    "Sorry, we don't have a preview at that address. Please check the link and contact the original provider if you still can't access it.",
  "econsentPdfPreview.linkExpired": "Link Expired",
  "econsentPdfPreview.linkExpiredInformation":
    "{firstName} {lastName} generated this preview on {generatedDate}. This link expired on {expirationDate}. Please request a new link from the original provider.",
  "econsentPdfViewer.signaturePreview": "Signature Preview",
  "econsentPdfViewer.cancel": "Cancel",
  "econsentPdfViewer.apply": "Apply",
  "econsentPdfViewer.signatoryName": "{firstName} {lastName}",
  "econsentPdfViewer.tapToSign": "Tap To Sign",
  "econsentPdfViewer.drawYourOwnSignature": "Draw Your Own Signature",
  "econsentPdfViewer.clear": "Clear",
  "econsentPdfViewer.optional": "Optional",
  "econsentPdfViewer.required": "Required",
  "econsentPdfViewer.textEntryEmptyScreenReader":
    "You can enter up to {maxLength} characters in this field",
  "econsentPdfViewer.textEntryNotEmptyScreenReader":
    "{currentLength} characters entered out of {maxLength} characters allowed",
  "econsentPdfViewer.sign": "Sign",
  "econsentPdfViewer.signDocument": "Sign Document",
  "econsentPdfViewer.howWouldYouLikeToSign": "How would you like to sign?",
  "econsentPdfViewer.autofilled": "(Autofilled)",
  "econsentPdfViewer.failedToDownloadPdf":
    "There was an error downloading the {pdf}",
  "econsentPdfViewer.document": "Document",
  "econsentPdfViewer.pageSelector": "Page Selector",
  "econsentPdfViewer.pageNumberThumbnail": "Page {number} Thumbnail",
  "econsentPdfViewer.pages": "Pages",
  "econsentPdfViewer.pageNumber": "Page {number}",
  "econsentPdfViewer.requiredSignature": "Required Signature",
  "econsentPdfViewer.optionalSignature": "Optional Signature",
  "econsentPdfViewer.requiredResponse": "Required Response",
  "econsentPdfViewer.optionalResponse": "Optional Response",
  "econsentPdfViewer.iHaveReviewedThisDocument":
    "I have reviewed this document and am ready to submit a signed copy.",
  "econsentPdfViewer.documentSubmitted": "Document Submitted",
  "econsentPdfViewer.pleaseReviewAndSignThisDocument":
    "Please review and sign this document.",
  "econsentPdfViewer.pleaseReviewAndSignThisDocumentWithDeclineButton":
    "Please review and sign this document. {link}",
  "econsentPdfViewer.completeAllRequiredSignatures":
    "To submit this document, complete all required signatures.",
  "econsentPdfViewer.completeAllRequiredSignaturesWithDecline":
    "To submit this document, complete all required signatures. {link} ",
  "econsentPdfViewer.documentPending":
    "You have another document pending. You can't sign this document until you complete all pending documents.",
  "econsentPdfViewer.declineToSignLink": "I don't want to sign this document.",
  "econsentPdfViewer.submit": "Submit",
  "econsentPdfViewer.downloadPDF": "Download {pdf}",
  "econsentPdfViewer.decline": "Decline",
  "econsentPdfViewer.declineDocument": "Decline Document",
  "econsentPdfViewer.documentDeclined": "Document Declined",
  "econsentPdfViewer.declineModalContentOtherRoles":
    "This declines the document for all reviewers and might mean the participant can't take part in the study. Please discuss your decision with your site coordinator if you're unsure.",
  "econsentPdfViewer.declineModalContentParticipant":
    "This might mean you can't participate in this study. Please discuss your decision with your site coordinator if you're unsure.",
  "econsentPdfViewer.declineModalTitle": "Decline this document?",
  "econsentPdfViewer.askForStudyHelp": "Request Study Help",
  "econsentPdfViewer.moreActions": "More Actions",
  "econsentPdfViewer.exportMenuLabel": "Export Methods",
  "econsentPdfViewer.signEconsentDocument": "Sign Document",
  "econsentPdfViewer.closeDialog": "Close dialog",
  "econsentPdfViewer.tryAgainDescriptionCall":
    "Make sure your device has a signal and request another code.",
  "econsentPdfViewer.tryAgainDescriptionText":
    "Make sure your device has a network connection and request another code.",
  "econsentPdfViewer.sendAnotherText": "Send Another Text",
  "econsentPdfViewer.receiveACall": "Receive A Call",
  "econsentPdfViewer.receiveAnotherCall": "Receive Another Call",
  "econsentPdfViewer.sendAText": "Send A Text",
  "econsentPdfViewer.verifyIdentity": "Confirm Your Identity – Text",
  "econsentPdfViewer.verifyIdentityVoiceCall":
    "Confirm Your Identity – Voice Call",
  "econsentPdfViewer.confirmIdentityHeadingDescriptionCall":
    "We're calling <span>{phone}</span> to give you a six-digit verification code. Enter it below.",
  "econsentPdfViewer.confirmIdentityHeadingDescriptionText":
    "We sent a text with a six-digit verification code to <span>{phone}</span>. Enter it below.",
  "econsentPdfViewer.somethingWentWrongDescription": "Please try again.",
  "econsentPdfViewer.unableToSendCodeMessage":
    "Sorry, we couldn't send your verification code. Check the number and try again.",
  "econsentPdfViewer.unableToSendTextMessage":
    "This number can't receive texts. Request a call to receive the code at this number.",
  "econsentPdfViewer.tooManyRequestsMessage":
    "We can't send another code to this number right now. Check the number and try again in 10 minutes.",
  "econsentPdfViewer.signatureImageAlt": "{name}'s signature",
  "econsentPdfViewer.completeBeforeSigning":
    "You must read each page and answer any required questions before you can apply your signature.",
  "econsentPdfViewer.close": "Close",
  "econsentPdfViewer.youDeclinedOn": "You declined this document on {date}.",
  "econsentPdfViewer.youDeclinedToday": "You declined this document today.",
  "econsentPdfViewer.youDeclinedYesterday":
    "You declined this document yesterday.",
  "econsentPdfViewer.reviewerDeclinedOn":
    "Another reviewer declined this document on {date}.",
  "econsentPdfViewer.reviewerDeclinedToday":
    "Another reviewer declined this document today.",
  "econsentPdfViewer.reviewerDeclinedYesterday":
    "Another reviewer declined this document yesterday.",
  "econsentPdfViewer.documentSubmittedOn":
    "You submitted this document on {date}.",
  "econsentPdfViewer.documentSubmittedToday":
    "You submitted this document today.",
  "econsentPdfViewer.documentSubmittedYesterday":
    "You submitted this document yesterday.",
  "econsentPdfViewer.signatureRequiresCode":
    "This document is ready to sign, but you need a code from the study site. <Button>Click here</Button> when they give you the code.",
  "econsentPdfViewer.announceSignatureRequiresCode":
    "This document is ready to sign, but you need a code from the study site.",
  "econsentPdfViewer.enterUnlockCode":
    "Enter the unlock code that your study site gave you.",
  "econsentPdfViewer.wrongUnlockCode":
    "Sorry, this code is invalid. Please double-check the code and try again.",
  "econsentPdfViewer.unlockSuccessful": "Unlock Successful",
  "econsentPdfViewer.unlockCodeTitle": "Unlock Code",
  "econsentPdfViewer.error.unlockError":
    "Sorry, we couldn't unlock this document. Please refresh the page and try again.",
  "econsentPdfViewer.error.session-expired-message":
    "Log in again to submit this consent form.",
  "econsentPdfViewer.error.documentNotAvailable":
    "This Document Is No Longer Available",
  "econsentPdfViewer.error.documentNotAvailableMessage":
    "This document was removed by the study team. Select OK to view your current tasks.",
  "econsentPdfViewer.error.conflict": "Document Declined by Another User",
  "econsentPdfViewer.error.conflictMessage":
    "Another user declined this form and you can no longer complete it. Select OK to view your remaining tasks.",
  "econsentPdfViewer.error.sessionTimeout": "Your Session Has Timed Out",
  "econsentPdfViewer.error.sessionTimeoutMessage":
    "Log in again to submit this consent form.",
  "econsentPdfViewer.error.declineSequenceError": "You Have Pending Documents",
  "econsentPdfViewer.error.declineSequenceErrorMessage":
    "You have another document pending. You cannot decline this document until you complete all pending documents.",
  "econsentPdfViewer.error.declineErrored":
    "Sorry, we're not able to submit your decision right now. Please try again later and contact your site if the problem continues.",
  "econsentPdfViewer.error.signSequenceError": "You Have Pending Documents",
  "econsentPdfViewer.error.signSequenceErrorMessage":
    "You have another document pending. You cannot sign this document until you complete all pending documents.",
  "econsentPdfViewer.error.submitErrored":
    "Sorry, we're not able to submit your document right now. Please try again later and contact your site if the problem continues.",
  "econsentPdfViewer.error.somethingWentWrong": "Something Went Wrong",
  "econsentPdfViewer.error.pleaseReloadBrowser":
    "Please refresh the page. Your progress will be restored from the last checkpoint.",
  "econsentPdfViewer.error.rescanQRCode":
    "Ask your study team to restart your session by scanning the QR code for in-person consent.",
  "econsentPdfViewer.error.blockConflictMessage":
    "Another signatory already answered one or more questions on this form. Reload the form to restore your progress from the last checkpoint.",
  "econsentPdfViewer.error.blockConflictTitle":
    "Question Answered by Another User",
  "econsentPdfViewer.ok": "OK",
  "econsent.closeDialog": "Close Dialog",
  "econsent.documentNotDownloaded": "Document not downloaded",
  "econsent.failedToDownloadPdf":
    "Sorry, we weren't able to download the document. Please try again later.",
  "econsentEditor.documentLanguageSettings": "Document Language Settings",
  "econsentEditor.pageCountLabelTooltipText":
    "You can use the following page number tokens to format the page number layout: <br></br>Current Page: [[curr_page_num]]<br></br>Total Pages: [[total_page_num]]",
  "econsentEditor.pageCount": "Page Count",
  "econsentEditor.pagePlaceholder":
    "Page [[curr_page_num]] of [[total_page_num]]",
  "econsentEditor.of": "of",
  "econsentEditor.x": "X",
  "econsentEditor.y": "Y",
  "econsentEditor.pageCountIsAppliedToThePrintDocument":
    "Page count is applied to the print document.",
  "econsentEditor.youMustEnterPageCountTooltip":
    "You must enter page count labels before you can save your changes to the footer.",
  "econsentEditor.headerTooltip":
    "The header content defined in these fields will be<br></br>applied to the print document.",
  "econsentEditor.footerTooltip":
    "The footer content defined in these fields will be<br></br>applied to the print document.",
  "econsentEditor.printContent": "Print Content",
  "econsentEditor.headerAndFooter": "Header and Footer",
  "econsentEditor.editHeader": "Edit Header",
  "econsentEditor.editFooter": "Edit Footer",
  "econsentEditor.addAnswerOption": "Add an answer option",
  "econsentEditor.addContentBlock": "Add content block",
  "econsentEditor.addImage": "Add Image",
  "econsentEditor.addMedia": "Add Media",
  "econsentEditor.addQuestionBlock": "Add Question Block",
  "econsentEditor.addSection": "Add section",
  "econsentEditor.addSignatureBlock": "Add signature block",
  "econsentEditor.addSignatureBlockDisabled":
    "You've added signature blocks for all of the available roles.",
  "econsentEditor.addTextBlock": "Add Text Block",
  "econsentEditor.alignCenterTitle": "Align Center",
  "econsentEditor.alignLeftTitle": "Align Left",
  "econsentEditor.alignNoneTitle": "Align None",
  "econsentEditor.alignRightTitle": "Align Right",
  "econsentEditor.answerLabel": "Answer Name",
  "econsentEditor.answerLabelContent": "Answer Text",
  "econsentEditor.answerText": "Answer Text",
  "econsentEditor.autoSave": "Autosave",
  "econsentEditor.blockConnected":
    "Data from this block will be sent to {sponsorName}.",
  "econsentEditor.blockTitle": "{sectionIndex}.{blockIndex}",
  "econsentEditor.browse": "Browse",
  "econsentEditor.cancel": "Cancel",
  "econsentEditor.confirm": "Confirm",
  "econsentEditor.leftColumn": "Left Column",
  "econsentEditor.center": "Center",
  "econsentEditor.rightColumn": "Right Column",
  "econsentEditor.save": "Save",
  "econsentEditor.input": "Input",
  "econsentEditor.changesFromPreviousSession":
    "Changes from your previous session weren't saved to {vault} due to a connection error. Your changes are being saved now.",
  "econsentEditor.checkIn": "Check In",
  "econsentEditor.checkInModalDescription":
    "Clicking Check In will save your changes to {vault} as a new document version, end your editing session, and unlock the document in {vault} so others can edit it.",
  "econsentEditor.checkingInYourDocument":
    "Checking in the document. You'll be redirected to {vault} when the check-in is complete.",
  "econsentEditor.chooseFileError":
    "Sorry, that file doesn't meet our requirements.<br></br>Please resize or reformat the file and try again.",
  "econsentEditor.clickToAddContentBlock": "Click to add content block",
  "econsentEditor.close": "Close",
  "econsentEditor.closeContentBlockModal": "Close add contact block dialog",
  "econsentEditor.closeDialog": "Close Dialog",
  "econsentEditor.closeModal": "Close dialog",
  "econsentEditor.closePopup": "Close popup",
  "econsentEditor.contentBlockAriaLabel":
    "Edit block {blockIndex} of section {sectionIndex}",
  "econsentEditor.contentBlocks": "Content Blocks",
  "econsentEditor.date": "Date",
  "econsentEditor.defaultRole": "Default",
  "econsentEditor.dimensions": "Dimensions: {dimensions}",
  "econsentEditor.documentConnectedToSponsor":
    "This document will send data to {sponsorName}.",
  "econsentEditor.documentName": "Document Name",
  "econsentEditor.documentUpdated": "Your document has been updated.",
  "econsentEditor.downloadDocx": "Download Word Document",
  "econsentEditor.downloadPDF": "Download {pdf}",
  "econsentEditor.downloadPDFError": "There was an error saving the {pdf}",
  "econsentEditor.dropAFileHereOrBrowseForOne":
    "Drop a file here or browse for one to add.",
  "econsentEditor.dropANewImageHereOrBrowseForOne":
    "Drop a new image here or browse for one.",
  "econsentEditor.dropYourFileHereToUploadIt":
    "Drop your file here to upload it.",
  "econsentEditor.eSignaturePlaceholderLabel": "eSignature Placeholder",
  "econsentEditor.eSignaturePlaceholderPlaceholder":
    "Your signature placeholder content",
  "econsentEditor.edit": "Edit",
  "econsentEditor.editImage": "Edit Image",
  "econsentEditor.editorPlaceHolder": "Your content",
  "econsentEditor.error.couldnt-be-saved-title":
    "Your changes couldn't be saved",
  "econsentEditor.error.couldnt-checkin-title":
    "Your changes couldn't be checked in",
  "econsentEditor.error.createOrGetEConsentByAuthor.415-message":
    "Sorry, the file type of the document you're trying to open isn't currently supported. Please ensure it was uploaded to {vault} as a {pdfExtensionUppercase} or {docxExtensionUppercase} file and try again.",
  "econsentEditor.error.createOrGetEConsentByAuthor.415-title":
    "Your document couldn't be opened",
  "econsentEditor.error.createOrGetEConsentByAuthor.500-message":
    "Please return to {vault} and try again, and contact your {vault} administrator if you continue to see this error.",
  "econsentEditor.error.createOrGetEConsentByAuthor.500-title":
    "Your document couldn't be opened",
  "econsentEditor.error.previewCouldntBeCreated": "Preview Couldn't Be Created",
  "econsentEditor.error.previewCouldntBeCreatedMessage":
    "Sorry, we weren't able to create the preview. Please try again later and contact your {vault} administrator if you continue to see this error.",
  "econsentEditor.error.saveEconsentByAuthor.400-checkin-message":
    "We couldn't check in your document due to restricted HTML formatting. Remove the restricted formatting in the blocks with borders and then try to check in your document again. Contact your site administrator if you need more help.",
  "econsentEditor.error.saveEconsentByAuthor.400-checkin-title":
    "Document not checked in",
  "econsentEditor.error.saveEconsentByAuthor.400-message":
    "We couldn't save your document due to restricted HTML formatting. Remove the restricted formatting in the blocks with borders and then try to save your document again. Contact your site administrator if you need more help.",
  "econsentEditor.error.saveEconsentByAuthor.400-title": "Document not saved",
  "econsentEditor.error.saveEconsentByAuthor.403-checkin-message":
    "We couldn't check in the document because the document is no longer checked out to you. Please return to {vault} to check out the document and continue editing.",
  "econsentEditor.error.saveEconsentByAuthor.403-message":
    "We couldn't save your changes to {vault} because the document is no longer checked out to you. Please return to {vault} to check out the document and continue editing.",
  "econsentEditor.error.saveEconsentByAuthor.500-message":
    "Please save or check in the document again, and contact your {vault} administrator if you continue to see this error.",
  "econsentEditor.error.saveEconsentByAuthor.503-checkin-message":
    "We couldn't check in your document to {vault} due to a connection error. Please reopen the editor from {vault} to automatically retry saving your changes.",
  "econsentEditor.error.saveEconsentByAuthor.503-checkin-title":
    "Your document couldn't be checked in",
  "econsentEditor.error.saveEconsentByAuthor.503-message":
    "We couldn't save your changes to {vault} due to a connection error. Please reopen the editor from {vault} to automatically retry saving your changes.",
  "econsentEditor.error.session-expired-message":
    "Please log in through {vault} to continue editing.",
  "econsentEditor.error.updateEConsentByAuthor.403-message":
    "We couldn't autosave your most recent changes because the document is no longer checked out to you. Please return to {vault} to check out the document and continue editing.",
  "econsentEditor.fileSize": "File Size: {size}",
  "econsentEditor.fileUploaded": "File Uploaded",
  "econsentEditor.format": "Format: <b>{format}</b>",
  "econsentEditor.help": "Help",
  "econsentEditor.image": "Image",
  "econsentEditor.imageAlignment": "Alignment:",
  "econsentEditor.imageDescriptionLabel": "Description",
  "econsentEditor.imageDescriptionPlaceholder":
    "This description is used as alternative text for screen readers and accessibility.",
  "econsentEditor.imageFormatsAccepted": "Formats: <b>{imageFormats}</b>",
  "econsentEditor.imageType": "Type: {type}",
  "econsentEditor.images": "Image",
  "econsentEditor.importCodeLabel": "Import code",
  "econsentEditor.importCodeModalError": "Invalid Import Code",
  "econsentEditor.importCodeModalTitle": "Paste Import Code",
  "econsentEditor.importCodeServerError":
    "Sorry, we couldn't verify the code. Please try pasting the code again, and contact your {vault} administrator if you continue to see this error.",
  "econsentEditor.importDocumentWillReplaceContent":
    "Importing a document will replace the current content, but you'll be able to undo your changes if you need to.",
  "econsentEditor.importJson": "Import JSON",
  "econsentEditor.importJsonFinalizeTitle": "Content Uploaded Successfully",
  "econsentEditor.importJsonTitle": "Upload JSON",
  "econsentEditor.importModalButton": "Import Document",
  "econsentEditor.importPopupLabel": "Import Methods",
  "econsentEditor.importTitle": "Import",
  "econsentEditor.importWithCode": "Import With Code",
  "econsentEditor.importWordDoc": "Import Microsoft Word (.docx)",
  "econsentEditor.jsonInputAriaLabel": "JSON input",
  "econsentEditor.larGuardian": "Guardian / Representative",
  "econsentEditor.caregiver": "Caregiver",
  "econsentEditor.secondLarGuardian": "Second Guardian / Representative",
  "econsentEditor.secondCaregiver": "Second Caregiver",
  "econsentEditor.secondWitness": "Second Witness",
  "econsentEditor.lastAutoSave": "Last autosave: {time}",
  "econsentEditor.maxFileSize": "Max File Size: <b>{filesize}</b>",
  "econsentEditor.numberMB": "{number} MB",
  "econsentEditor.media": "Media",
  "econsentEditor.mediaInputAriaLabel": "Media input",
  "econsentEditor.missingFollowingElements":
    "Your document is missing the following elements:",
  "econsentEditor.missingFooter": "A footer",
  "econsentEditor.missingHeader": "A header",
  "econsentEditor.missingLabelsTooltip":
    "You cannot save or check in this document while signature, printed name, or printed date labels are missing.",
  "econsentEditor.missingSignatureBlockForParticipant":
    "A signature block for a participant or representative",
  "econsentEditor.missingSignatureBlockForSite":
    "A signature block for a site staff member",
  "econsentEditor.missingSignatureBlockForRole":
    "A signature block for one of the roles assigned to a question",
  "econsentEditor.missingSignatureLabelsTooltip":
    "You must enter labels for the Signature, Printed Name, and Date fields on all Signature Blocks before you can check in or save your document to {vault}.",
  "econsentEditor.missingSiteSignaturePlaceholderTooltip":
    "You must enter an eSignature Placeholder before you can check in or save your document to {vault}.",
  "econsentEditor.moveContentBlockDownTitle": "Move block {index} down one",
  "econsentEditor.moveContentBlockUpTitle": "Move block {index} up one",
  "econsentEditor.moveOptionDownOne": "Move option down one",
  "econsentEditor.moveOptionUpOne": "Move option up one",
  "econsentEditor.moveSectionDownTitle": "Move section {index} down one",
  "econsentEditor.moveSectionUpTitle": "Move section {index} up one",
  "econsentEditor.no": "No",
  "econsentEditor.noIdProvided":
    "Invalid address. Please access the editor from {vault}.",
  "econsentEditor.optionLabel": "Option {optionNumber} of block {blockNumber}",
  "econsentEditor.participant": "Participant",
  "econsentEditor.placeholder": "Placeholder",
  "econsentEditor.popupSavedToVaultVersion":
    "Version {majorVersion}.{minorVersion}",
  "econsentEditor.printedName": "Printed Name",
  "econsentEditor.problemWithFileUpload":
    "Sorry, we couldn't upload your file. Please try again.",
  "econsentEditor.proxy": "Proxy",
  "econsentEditor.questionBlock": "Question Block",
  "econsentEditor.questionLabel": "Question Name",
  "econsentEditor.questionLabelContent": "Question Text Content",
  "econsentEditor.questionRoleTooltip":
    "You can optionally assign this block to a role. By default, this block is assigned to the first available recipient in the following order: Proxy, Guardian(s), Participant, Witness, Translator.",
  "econsentEditor.redactor.subheading": "Subheading {number}",
  "econsentEditor.redirectingToVault":
    "Check-in complete. You're being redirected to {vault}.",
  "econsentEditor.removeContentBlockTitle": "Remove block {index}",
  "econsentEditor.removeMedia": "Remove media",
  "econsentEditor.removeOption": "Remove option",
  "econsentEditor.removeSectionTitle": "Remove section {index}",
  "econsentEditor.removeThisBlock": "Remove this block?",
  "econsentEditor.removeThisOption": "Remove this option?",
  "econsentEditor.removeThisSection": "Remove this section?",
  "econsentEditor.requiredPatientFriendlyTitle":
    "Patient-Friendly Title (Required)",
  "econsentEditor.requiredResponse": "Required Response",
  "econsentEditor.requiresLiveSignature": "Requires Hand-Drawn Signature",
  "econsentEditor.requiresLiveSignatureSponsorTooltip":
    "Participants will need to draw their signature. This was set by the sponsor and can't be disabled while the form is connected.",
  "econsentEditor.requiresLiveSignatureTooltip":
    "Participants will need to draw their signature on a device.",
  "econsentEditor.requiresUnlockCode": "Requires Unlock Code to Sign",
  "econsentEditor.resumeEditing": "Resume Editing",
  "econsentEditor.returnToVault": "Click here to return to {vault}",
  "econsentEditor.rightToLeftLanguage": "Right to Left Language",
  "econsentEditor.role": "Role",
  "econsentEditor.saveIncompleteEconsent": "Save incomplete {econsent}?",
  "econsentEditor.saveToVault": "Save to {vault}",
  "econsentEditor.saveToVaultModalDescription":
    "Clicking Save to {vault} will save your changes to {vault} as a new document version without ending your editing session.",
  "econsentEditor.saved": "Saved",
  "econsentEditor.savedToVault": "{version} Saved to {vault}",
  "econsentEditor.saving": "Saving",
  "econsentEditor.savingToVault": "Saving to {vault}",
  "econsentEditor.savingYourProgress": "Saving your progress",
  "econsentEditor.savingYourProgressDescription":
    "You don't need to manually back up your progress; we've got you covered. Click Save to {vault} when you're ready to store a new version in {vault}; otherwise, we'll automatically capture your progress in the editor.",
  "econsentEditor.sectionAriaLabel": "Edit section number {sectionIndex}",
  "econsentEditor.sectionNumber": "Section {number}",
  "econsentEditor.sectionTitle": "{sectionIndex}.",
  "econsentEditor.sections": "Sections",
  "econsentEditor.settings": "Settings",
  "econsentEditor.setDocumentToRTL": "Set Document to Right to Left",
  "econsentEditor.setDocumentToLTR": "Set Document to Left to Right",
  "econsentEditor.setDocumentToRTLDescription":
    "Enabling this setting mirrors UI elements to be displayed for right to left languages. Select Confirm to change the UI to be displayed from right to left.",
  "econsentEditor.setDocumentToLTRDescription":
    "Disabling this setting mirrors UI elements to be displayed for left to right languages. Select Confirm to change the UI to be displayed from left to right.",
  "econsentEditor.showTextContent": "Show Text Content",
  "econsentEditor.showTitle": "Show Title",
  "econsentEditor.shownInVault": "(shown in {vault})",
  "econsentEditor.signature": "Signature",
  "econsentEditor.signatureBlock": "Signature Block",
  "econsentEditor.signatureLabel": "Signature Name",
  "econsentEditor.signatureLabelContent": "Signature Text Content",
  "econsentEditor.signaturePreview":
    "A text field will be displayed here on the consent form.",
  "econsentEditor.editorSettings": "Editor settings",
  "econsentEditor.lockUnlockForSites": "Lock/Unlock for Sites",
  "econsentEditor.lockUnlockTooltip":
    "This setting locks or unlocks the whole document. Select Lock All to prevent sites from editing the document or Unlock All to allow it. You can also lock or unlock specific content blocks as needed.",
  "econsentEditor.lockAll": "Lock All",
  "econsentEditor.unlockAll": "Unlock All",
  "econsentEditor.allowEdits": "Allow Edits",
  "econsentEditor.lockAllMessage":
    "Selecting this toggle moves all toggles to the locked state and prevents site staff from making changes to this {econsent} form.",
  "econsentEditor.unlockAllMessage":
    "Selecting this toggle moves all toggles to the unlocked state and allows sites to edit related content.",
  "econsentEditor.signatureRequirements": "Signature Requirements",
  "econsentEditor.signingOrder": "Signing Order",
  "econsentEditor.signingOrderTooltip":
    "You can enter a Signing Order for this document if a participant needs to sign it before or after signing other documents. For example, a document with a Signing Order of 1 must be signed before a document with a Signing Order of 2.",
  "econsentEditor.site": "Site",
  "econsentEditor.tableOfContentContentBlockAriaLabel":
    "Content block {blockName} index {blockIndex} of section {sectionIndex}",
  "econsentEditor.tableOfContentSectionAriaLabel":
    "Section {sectionName} index {sectionIndex}",
  "econsentEditor.tableOfContents": "Table of Contents",
  "econsentEditor.textBlock": "Text Block",
  "econsentEditor.theSponsor": "the sponsor",
  "econsentEditor.title": "Title",
  "econsentEditor.tooManyFiles":
    "Sorry, you can only upload one file at a time.",
  "econsentEditor.translator": "Translator",
  "econsentEditor.undoChanges": "Undo Changes",
  "econsentEditor.unlockCodeTooltip":
    "Participants need a code to sign this document. Site staff will create the code in the preview opened from {sitevault} and provide it to them.",
  "econsentEditor.unsupportedContent": "Unsupported HTML removed",
  "econsentEditor.unsupportedContentDescription":
    "We removed unsupported HTML from what you pasted into the editor. Please verify that the content you wanted was added.",
  "econsentEditor.untitled": "Untitled",
  "econsentEditor.update": "Update",
  "econsentEditor.versionComments": "Version Comments (Optional)",
  "econsentEditor.video": "Video",
  "econsentEditor.webPreview": "Web Preview",
  "econsentEditor.witness": "Witness",
  "econsentEditor.wordInputAriaLabel": "Word input",
  "econsentEditor.yes": "Yes",
  "econsentEditor.yourChangesAreBeingSavedRightNow":
    "Your changes are being saved right now.",
  "econsentEditor.yourImage": "Your image",
  "econsentEditor.allowSiteEdits": "Allow Site Edits",
  "econsentEditor.allowSiteEditsTooltip":
    "Enabling this toggle will allow sites to provide details or make changes to the content within this block.",
  "econsentEditor.lockedContentTooltip":
    "This content block has been locked by the study sponsor. Please contact the sponsor if you need to edit the content.",
  "econsentEditor.lockedContentPopupHeader":
    "This document includes locked content.",
  "econsentEditor.lockedContentPopupMessage":
    "Please contact the study sponsor if you need to edit the locked content.",
  "econsentEditor.rightToLeftTooltip":
    "Enabling Right to Left Language updates the form to correctly display the UI for languages that are written and read from right to left, such as Arabic and Hebrew. The alignment of text elements is adjusted accordingly.",
  "econsentGenerate.errorMessage":
    "Sorry, we couldn't display the QR code. <br></br>Please refresh this page or visit the link below.",
  "econsentGenerate.helpText":
    "If your device can't scan the QR code, you can go to this web address to begin.",
  "econsentGenerate.instructions":
    "Scan the QR code below with your device's camera to begin the in-person consent process, or go to the address below.",
  "econsentGenerate.qrCodeAltText": "QR Code",
  "econsentGenerate.somethingWentWrong":
    "Sorry, we couldn't create the in-person consent code because the document wasn't sent successfully. <br></br>Please resend the document then view the code.",
  "econsentGenerate.title": "In-Person Consent Code",
  "econsentPreview.shareButtonText": "Share With Code",
  "econsentPreview.unlockCodeErrorMessage":
    "Sorry, we could not create the unlock code. Please refresh the page and try again.",
  "econsentPreview.unlockCodeErrorTitle": "Your Code Could Not Be Created",
  "econsentPreview.unlockCodeSubtext": "Unlock Code: {code}",
  "econsentPreview.shareModalTitle": "Share With Import Code",
  "econsentPreview.close": "Close",
  "econsentPreview.copiedTooltip": "Copied",
  "econsentPreview.generateShareCodeError":
    "Sorry, we couldn't create the code. Please try to share the document again, and contact your {vault} administrator if you continue to see this error.",
  "econsentPreview.shareStepOne":
    "Copy the import code above. You can send this code to someone else or use it to import this document into your own {vault}.",
  "econsentPreview.shareStepTwo":
    "If importing into your own {vault}, {loginLink}, create a new blank {icf} or a new draft of an existing blank {icf}, and edit the {econsent} form.",
  "econsentPreview.shareStepThree":
    "Click the {import} button, select {importWithCode}, and paste the code to import the content.",
  "econsentPreview.shareStepFour":
    "Save the document to {vault}. We recommend saving a version to {vault} before you begin editing, so that you always have a version that represents the original imported content.",
  "econsentPreview.shareModalLoginLink": "log in to {vault}",
  "econsentPreview.import": "Import",
  "econsentPreview.importWithCode": "Import With Code",
  "econsentPreview.shareModalHelpLink": "Editing {econsent} Forms",
  "econsentPreview.shareModalHelpMessage":
    "See {helpLink} in {sitevault} Help for more information.",
  "econsentPreview.codeExpiryMessage": "This code will expire in {expiration}.",
  "econsentPreview.codeExpiryMessageDate":
    "This code will expire on {expiration}.",
  "econsentPreview.createNewCode": "Create New Code",
  "econsentPreview.codeExpiredMessage": "This code has expired.",
  "econsentPreview.unlockCodeTitle": "Unlock Code",
  "econsentPreview.createCodeButton": "Create Code",
  "econsentPreview.selectOption": "Select an option",
  "econsentPreview.codeWillExpire": "Code will expire in:",
  "econsentPreview.createUnlockCodeMessage":
    "Release this document for signature by sharing the unlock code with your participants or signatories.",
  "econsentPreview.createUnlockCodeTitle": "Create Unlock Code",
  "econsentPreview.actionNotAvailableInPreview":
    "Action Not Available in Preview Mode",
  "econsentPreview.appUserActions": "APP USER ACTIONS",
  "econsentPreview.declineEconsentUnavailable":
    "A study participant would be sent to the To Do tab.",
  "econsentPreview.expiredGenerationInformation":
    "{firstName} {lastName} generated this preview on {generatedDate}. This link expired on {expirationDate}. Please request a new link from the original provider.",
  "econsentPreview.failedToOpenPreview":
    "Sorry, we weren't able to open the preview. Please refresh the page to try again, and contact the original link provider if you still can't access it.",
  "econsentPreview.generationInformationApprovedVersion":
    "{firstName} {lastName} generated this preview on {generatedDate}.",
  "econsentPreview.generationInformationExpirationDate":
    "{firstName} {lastName} generated this preview on {generatedDate}. This link will expire on {expirationDate}.",
  "econsentPreview.help": "Help",
  "econsentPreview.invalidEditorPreviewLinkDescription":
    "Sorry, we don't have a preview at that address. Please return to the editor and open the preview from there.",
  "econsentPreview.invalidGlobalPreviewLinkDescription":
    "Sorry, we don't have a preview at that address. Please check the link and contact the original provider if you still can't access it.",
  "econsentPreview.invalidLink": "Invalid Link",
  "econsentPreview.linkExpired": "Link Expired",
  "econsentPreview.loginToVault":
    "Log in through {vault} to view this preview.",
  "econsentPreview.invalidSignatoryRole": "Invalid Signatory Role",
  "econsentPreview.invalidSignatoryRoleMessage":
    "The role in the URL is not supported. Please replace it with one of these supported roles: proxy, guardian, secondguardian, caregiver, secondcaregiver, participant, witness, secondwitness, or translator.",
  "econsentPreview.previewActions": "PREVIEW ACTIONS",
  "econsentPreview.previewCouldntBeOpened": "Preview Couldn't Be Opened",
  "econsentPreview.previewCouldntBeOpenedMessage":
    "Sorry, we weren't able to open the preview. Please refresh the page to try again.",
  "econsentPreview.previewDefaultName": "Signature Preview",
  "econsentPreview.previewModalMessage":
    "You can perform actions such as signing, declining, and downloading the document, but your actions will not be saved.",
  "econsentPreview.previewModalTitle": "This Document Is in Preview Mode",
  "econsentPreview.previewMode": "PREVIEW MODE",
  "econsentPreview.previewNotAvailable": "Preview No Longer Available",
  "econsentPreview.previewRemovedMessage":
    "Sorry, this preview was removed by the study site.",
  "econsentPreview.submitUnavailable":
    "A study participant would be required to verify their identity with a code sent to their phone.",
  "econsentPreview.unlockUnavailable":
    "A study participant would be required to enter an unlock code provided by the study team before continuing.",
  "econsentPreview.copyButtonTitle": "Copy to Clipboard",
  "econsentUnlock.errorMessage":
    "Sorry, we couldn't unlock this document. Please refresh the page and try again.",
  "econsentUnlock.errorWrongCode":
    "Sorry, this code is invalid. Please double-check the code and try again.",
  "econsentViewer.liveSignatureResized":
    "The window was resized while signing. Please redraw your signature to make sure it is accurately captured.",
  "econsentViewer.apply": "Apply",
  "econsentViewer.askForStudyHelp": "Request Study Help",
  "econsentViewer.blockConflictMessage":
    "Another signatory already answered one or more questions on this form. Reload the form to restore your progress from the last checkpoint.",
  "econsentViewer.blockConflictTitle": "Question Answered by Another User",
  "econsentViewer.blockLabel": "Scroll to {name}",
  "econsentViewer.cancel": "Cancel",
  "econsentViewer.clear": "Clear",
  "econsentViewer.clearSignature": "Clear Signature",
  "econsentViewer.close": "Close",
  "econsentViewer.closeDialog": "Close dialog",
  "econsentViewer.closeTableOfContents": "Close Table of Contents",
  "econsentViewer.collapseSection": "Collapse section",
  "econsentViewer.collapseSectionLabel": "Collapse section titled {name}",
  "econsentViewer.conflictMessage":
    "Another user declined this form and you can no longer complete it. Select OK to view your remaining tasks.",
  "econsentViewer.conflictTitle": "Document Declined by Another User",
  "econsentViewer.date": "Date",
  "econsentViewer.dateHelperText": "(Added on submission)",
  "econsentViewer.declineButton": "Decline",
  "econsentViewer.declineDocument": "Decline Document",
  "econsentViewer.declineErrored":
    "Sorry, we're not able to submit your decision right now. Please try again later and contact your site if the problem continues.",
  "econsentViewer.declineModalContentOtherRoles":
    "This declines the document for all reviewers and might mean the participant can't take part in the study. Please discuss your decision with your site coordinator if you're unsure.",
  "econsentViewer.declineModalContentParticipant":
    "This might mean you can't participate in this study. Please discuss your decision with your site coordinator if you're unsure.",
  "econsentViewer.declineModalTitle": "Decline this document?",
  "econsentViewer.declineToSignLink": "I don't want to sign this document.",
  "econsentViewer.document": "Document",
  "econsentViewer.documentNotAvailable": "This Document Is No Longer Available",
  "econsentViewer.documentPendingErrorTitle": "You Have Pending Documents",
  "econsentViewer.documentPendingDeclineError":
    "You have another document pending. You cannot decline this document until you complete all pending documents.",
  "econsentViewer.documentPendingSignError":
    "You have another document pending. You cannot sign this document until you complete all pending documents.",
  "econsentViewer.documentRemoved":
    "This document was removed by the study team. Select OK to view your current tasks.",
  "econsentViewer.documentDeclined": "Document Declined",
  "econsentViewer.documentSubmitted": "Document Submitted",
  "econsentViewer.documentSubmittedOn":
    "You submitted this document on {date}.",
  "econsentViewer.documentSubmittedToday": "You submitted this document today.",
  "econsentViewer.documentSubmittedYesterday":
    "You submitted this document yesterday.",
  "econsentViewer.downloadDocx": "Download Word Document",
  "econsentViewer.downloadPDF": "Download {pdf}",
  "econsentViewer.drawYourOwnSignature": "Draw Your Own Signature",
  "econsentViewer.enterUnlockCode":
    "Enter the unlock code that your study site gave you.",
  "econsentViewer.enterUnlockCodeLabel": "Enter Unlock Code",
  "econsentViewer.expandSection": "Expand section",
  "econsentViewer.expandSectionLabel": "Expand section titled {name}",
  "econsentViewer.exportMenuLabel": "Export Methods",
  "econsentViewer.generateShareCodeError":
    "Sorry, we couldn't create the code. Please try to share the document again, and contact your {vault} administrator if you continue to see this error.",
  "econsentViewer.hotdogMenuTitle": "More Actions",
  "econsentViewer.nextSection": "Next Section",
  "econsentViewer.nextSectionLabel": "Go to next section titled {name}",
  "econsentViewer.orHandDrawSignature":
    "or you can <button>draw your own signature</button>",
  "econsentViewer.pageExpiredContent":
    "Please check your email for the password reset link or select OK to return to the login page.",
  "econsentViewer.pendingDocuments":
    "You have another document pending. You can't sign this document until you complete all pending documents.",
  "econsentViewer.pleaseLoginAgain":
    "Log in again to submit this consent form.",
  "econsentViewer.pleaseReloadBrowser":
    "Please refresh the page. Your progress will be restored from the last checkpoint.",
  "econsentViewer.pleaseReviewAndSignThisDocument":
    "Please review and sign this document. {link}",
  "econsentViewer.previewingPendingDocument":
    "You're previewing this document, but you have another document pending.",
  "econsentViewer.previousSection": "Previous Section",
  "econsentViewer.previousSectionLabel": "Go to previous section titled {name}",
  "econsentViewer.printedName": "Printed Name",
  "econsentViewer.receiveACall": "Receive A Call",
  "econsentViewer.receiveAnotherCall": "Receive Another Call",
  "econsentViewer.responseRequired": "Your response is required",
  "econsentViewer.reviewerDeclinedOn":
    "Another reviewer declined this document on {date}.",
  "econsentViewer.reviewerDeclinedToday":
    "Another reviewer declined this document today.",
  "econsentViewer.reviewerDeclinedYesterday":
    "Another reviewer declined this document yesterday.",
  "econsentViewer.sectionLabel": "Select section titled {name}",
  "econsentViewer.sectionNumber": "Section {number}",
  "econsentViewer.sendAText": "Send A Text",
  "econsentViewer.sendAnotherText": "Send Another Text",
  "econsentViewer.signEconsentDocument": "Sign Document",
  "econsentViewer.signHere": "Sign Here",
  "econsentViewer.signature": "Signature",
  "econsentViewer.signatureImageAlt": "{name}'s signature",
  "econsentViewer.signatureRequiresCode":
    "This document is ready to sign, but you need a code from the study site. Click here when they give you the code.",
  "econsentViewer.somethingWentWrong": "Something Went Wrong",
  "econsentViewer.submissionErrored":
    "Sorry, we're not able to submit your document right now. Please try again later and contact your site if the problem continues.",
  "econsentViewer.submit": "Submit",
  "econsentViewer.submitDescription":
    "I have reviewed the document and am ready to submit the signed copy.",
  "econsentViewer.tableOfContents": "Table of Contents",
  "econsentViewer.tryAgainDescriptionCall":
    "Make sure your device has a signal and request another code.",
  "econsentViewer.tryAgainDescriptionText":
    "Make sure your device has a network connection and request another code.",
  "econsentViewer.unlockSuccessful": "Unlock Successful",
  "econsentViewer.unlockCodeTitle": "Unlock Code",
  "econsentViewer.useTapToSign": "Tap to Sign Instead",
  "econsentViewer.verifyIdentity": "Confirm Your Identity – Text",
  "econsentViewer.verifyIdentityVoiceCall":
    "Confirm Your Identity – Voice Call",
  "econsentViewer.viewEverythingToSign":
    "Please read or complete all sections on the table of contents before signing this document.",
  "econsentViewer.viewUncompletedSection": "View uncompleted section.",
  "econsentViewer.youDeclinedOn": "You declined this document on {date}.",
  "econsentViewer.youDeclinedToday": "You declined this document today.",
  "econsentViewer.youDeclinedYesterday":
    "You declined this document yesterday.",
  "econsentViewer.yourSessionHasTimedOut": "Your Session Has Timed Out",
  "enterMfa.calling": "Calling ({time}s)",
  "enterMfa.callingPhoneNumberLinkedToEmail":
    "We're calling the phone number linked to <b><span>{email}</span></b> to give you a six-digit verification code.",
  "enterMfa.didntGetTheCallCode":
    "Didn't get the code? Make sure your phone has a signal and then try another call.",
  "enterMfa.didntGetTheCode": "Didn't get the code?",
  "enterMfa.enterMFACode": "Verification code",
  "enterMfa.enterMfaStep": "Step 2 of 2: ",
  "enterMfa.getAnotherCall": "Get Another Call",
  "enterMfa.getVoiceCall": "Get a Voice Call",
  "enterMfa.invalidCode":
    "The code you entered is invalid. Please reenter the code and try again.",
  "enterMfa.noMoreAttempts":
    "Still didn't get the code? Sorry, we're having trouble reaching you. Please contact your site administrator to verify your phone number.",
  "enterMfa.phoneNumberLinkedToEmail":
    "We've sent a six-digit verification code to the number linked to <b><span>{email}</span></b>.",
  "enterMfa.phoneNumberMessage":
    "We've sent a six-digit verification code to your number ending with <span><b>{digits}</b></span>.",
  "enterMfa.pleaseLoginAgain":
    "We logged you out while you were inactive. Please select OK to log in and verify your identity again.",
  "enterMfa.resend": "Send Another Code",
  "enterMfa.resendFailed":
    "We're unable to send you a verification code. Please log back in and try again.",
  "enterMfa.sent": "Sent ({time}s)",
  "enterMfa.title": "Confirm Your Identity – Text",
  "enterMfa.titleVoiceCall": "Confirm Your Identity – Voice Call",
  "enterMfa.tryVoiceCall":
    "Sorry, we're having trouble texting you. <br></br>Please try a voice call.",
  "enterMfa.voiceCallMessage":
    "We're calling your number ending with <span><b>{digits}</b></span> to give you a six-digit verification code.",
  "enterMfa.yourSessionHasTimedOut": "Your session has timed out",
  "entry.account": "Account",
  "entry.addedOnDate": "Added {date}",
  "entry.addedToday": "Added today",
  "entry.addedYesterday": "Added yesterday",
  "entry.copyOnDate": "Copy received {date}",
  "entry.copyToday": "Copy received today",
  "entry.copyYesterday": "Copy received yesterday",
  "entry.continue": "Continue",
  "entry.declinedOnDate": "Declined {date}",
  "entry.declinedToday": "Declined today",
  "entry.declinedYesterday": "Declined yesterday",
  "entry.help": "Help",
  "entry.loggedOutWhileInactive":
    "We logged you out while you were inactive. Please select OK to log in again.",
  "entry.logout": "Log Out",
  "entry.myVeevaAccount": "{myveeva} Account",
  "entry.new": "New",
  "entry.password": "Password",
  "entry.privacyPolicy": "Privacy Policy",
  "entry.signedOnDate": "Signed {date}",
  "entry.signedToday": "Signed today",
  "entry.signedYesterday": "Signed yesterday",
  "entry.todo": "To Do",
  "entry.study": "Study",
  "entry.termsOfService": "Terms of Service",
  "entry.viewedOnDate": "Viewed {date}",
  "entry.viewedToday": "Viewed today",
  "entry.viewedYesterday": "Viewed yesterday",
  "entry.back": "Back",
  "entry.navigateBack": "navigate back",
  "activateNewStudy.cantActivateStudy": "Can't Activate Study",
  "activateNewStudy.differentRegionError":
    "This activation code is for a study in a different geographic region from your current account. Please log out and use this activation code to register a new account.",
  "activateNewStudy.studyAddedSuccessfully":
    "Study {studyName} added successfully.",
  "activateNewStudy.createNewAccountError":
    "You have to create a new account to use this code. Please log out and use this activation code to register a new account in the {myveeva} mobile app.",
  "settings.name": "Name",
  "settings.formattedName": "{firstName} {lastName}",
  "settings.accountInformation": "Account Information",
  "settings.accountInformationDescription":
    "Your password is required to update this information.",
  "settings.accountSettings": "Account Settings",
  "settings.learnAboutDeletingYourAccount": "Learn about deleting your account",
  "settings.username": "Username",
  "settings.email": "Email",
  "settings.phone": "Phone",
  "settings.timeZone": "Time Zone",
  "settings.cancel": "Cancel",
  "settings.invalidEmail":
    "We are unable to accept that email address. Please enter a different email address.",
  "settings.emailUpdateError":
    "Sorry, we couldn't update your email. Please try again.",
  "settings.editUsername": "Edit Username",
  "settings.editUsernameConfirmPassword":
    "To edit your username, please enter your password.",
  "settings.usernameUpdated": "Username Updated",
  "settings.addPhoneNumber": "Add Phone Number",
  "settings.phoneUpdated": "Phone Updated",
  "settings.phonePasswordMessage":
    "To update your phone number, please enter your password.",
  "settings.editPhone": "Edit Phone",
  "settings.usernameAlreadyTaken":
    "Username is already in use. Try a different username.",
  "settings.emailUpdated": "Email Updated",
  "settings.addEmail": "Add Email",
  "settings.editEmail": "Edit Email",
  "settings.editEmailConfirmPassword":
    "To update your email, please enter your password.",
  "settings.emailSent":
    "We sent an email to <span><b>{email}</b></span>. Click the link in the email to complete adding your email.",
  "settings.emailPendingBanner":
    "We sent an email to <span><b>{email}</b></span>. You'll need to verify your new email before you can make changes to other settings. {resendLink}",
  "settings.resendEmail": "Resend Email",
  "settings.emailTooltip":
    "You'll need to verify your identity to change your email address. We'll continue using your current email address for logging in until you do.",
  "settings.leavePageMessage":
    "Do you want to leave this page? Changes you made may not be saved.",
  "settings.usernameUpdateError":
    "Sorry, we couldn't update your username. Please try again.",
  "settings.phoneTooltip":
    "We use your phone number only to verify your identity.",
  "settings.timeZoneTooltip":
    "Your time zone is controlled by your browser settings.",
  "settings.phoneNumber": "Phone Number",
  "settings.passwordModalUserError": "Incorrect password",
  "settings.passwordModalServerError":
    "Sorry, we're having server issues. Please try again.",
  "settings.passwordModalTitle": "Confirm Your Identity",
  "settings.passwordModalContent":
    "Please enter your password to confirm your identity.",
  "settings.password": "Password",
  "settings.editPassword": "Edit Password",
  "settings.editPasswordMessage":
    "To edit your password, please enter your current password.",
  "settings.passwordUpdated": "Password Updated",
  "settings.currentPassword": "Current Password",
  "settings.save": "Save",
  "settings.continue": "Continue",
  "settings.phoneMfaTitleCall": "Confirm Phone Number – Voice Call",
  "settings.phoneMfaTitleText": "Confirm Phone Number – Text",
  "settings.closeDialog": "Close Dialog",
  "settings.loggedOut": "Logged Out",
  "settings.loggedOutWhileInactive":
    "We logged you out while you were inactive. Please select OK to log in again.",
  "settings.linkExpired": "Link Expired",
  "settings.linkExpiredMessage":
    "Please return to the Settings page and request a new link.",
  "settings.returnToSettings": "Return to Settings",
  "settings.viewSteps": "View Steps",
  "account.helpGuide": "Help Guide",
  "account.helpGuideSecondaryText": "Search App FAQs and Help Topics",
  "account.settings": "Settings",
  "account.formattedName": "{firstName} {lastName}",
  "account.privacyPolicy": "Privacy Policy",
  "account.logOut": "Log Out",
  "account.myStudies": "My Studies",
  "account.myStudies.switchStudies": "Switch Studies",
  "account.myStudies.close": "Close",
  "account.myStudies.participant": "Participant",
  "account.myStudies.proxy":
    "Proxy for {firstName} {lastName} {siteParticipantId}",
  "account.myStudies.translator":
    "Translator for {firstName} {lastName} {siteParticipantId}",
  "account.myStudies.witness":
    "Witness for {firstName} {lastName} {siteParticipantId}",
  "account.myStudies.guardian":
    "Guardian/Representative of {firstName} {lastName} {siteParticipantId}",
  "account.myStudies.caregiver":
    "Caregiver for {firstName} {lastName} {siteParticipantId}",
  "account.myStudies.cancel": "Cancel",
  "account.myStudies.switch": "Switch",
  "account.myStudies.notificationCountSingle": "{count} notification",
  "account.myStudies.notificationCountMultiple": "{count} notifications",
  "account.myStudies.activateNewStudy": "Activate New Study",
  "account.myStudies.switchedToStudy": "Switched to {studyName}.",
  "tasks.review": "Review",
  "tasks.preview": "Preview",
  "tasks.newVersion": "New Version",
  "todo.today": "Today",
  "todo.tomorrow": "Tomorrow",
  "todo.noItemsToday": "No items due today.",
  "todo.noItemsTomorrow": "No items due tomorrow.",
  "todo.completeAsNeeded": "COMPLETE AS NEEDED",
  "todo.viewCompleted": "View Completed",
  "todo.completed": "Completed",
  "todo.somethingWentWrong": "Something Went Wrong",
  "todo.close": "Close",
  "todo.visitNotFoundTitle": "Select OK to view your current to-do's.",
  "todo.visitNotFoundMessage": "Visit Not Available",
  "trainingViewer.trainingPercentComplete":
    "{progressPercentage}<br></br><size>training complete</size>",
  "trainingViewer.training": "Training",
  "previewTrainingViewer.trainingSurvey": "Training Survey",
  "previewTrainingViewer.previewWarning":
    "This is a preview only. Responses are not saved.",
  "previewTrainingViewer.submitWarning":
    "This survey is a preview only. Your responses are not saved or visible to others",
  "previewTrainingViewer.close": "Close",
  "study.participantId": "Participant ID: {participantId}",
  "study.studyImageAlt": "Study Image",
  "study.contactStudyTeam": "Contact Your Study Team",
  "study.callContact": "Call Contact",
  "study.resources": "Resources",
  "study.sharedResourceCount": "{resourceCount} Shared Resources",
  "study.oneSharedResource": "{resourceCount} Shared Resource",
  "study.sharedDocuments": "Shared Documents",
  "study.trainingMaterials": "Training Materials",
  "study.websiteLinks": "Website Links",
  "study.mockResourceTitle": "Site Shared Resource",
  "study.mockResourceDate": "Added [Month, Day, Year]",
  "study.consentForms": "Consent Forms",
  "study.popupsBlockedMessage": "Enable popups to see this consent form.",
  "study.consentCopyError": "There was an error viewing the consent form",
  "study.consentCount":
    "{signedConsentCount} Signed, {declinedConsentCount} Declined",
  "study.details": "Details",
  "study.studyInformation": "Study Information",
  "study.needAssistance": "Need Assistance?",
  "study.askForStudyHelp": "Request Study Help",
  "study.askForHelpTooltip":
    "You can request non-emergency help from your study team with this form.",
  "resources.popupsBlockedMessage": "Enable popups to see this resource.",
  "studyDetails.studyLanguage": "Study Language",
  "studyDetails.studyDescription": "Description",
  "askForHelp.close": "Close",
  "askForHelp.formDescription":
    "Use this form to request non-emergency help from your study team. The response will not be immediate, but a team member will contact you as soon as they can.",
  "askForHelp.formTitle": "Study Help Request",
  "askForHelp.topicLabel": "What topic do you have a question about?",
  "askForHelp.contactLabel": "What is your preferred method of contact?",
  "askForHelp.selectAnOption": "Select an Option",
  "askForHelp.submit": "Submit",
  "askForHelp.survey": "A Survey",
  "askForHelp.visit": "A Visit",
  "askForHelp.studyParticipation": "My Study Participation",
  "askForHelp.somethingElse": "Something Else",
  "askForHelp.phoneCall": "Phone Call",
  "askForHelp.textMessage": "Text Message",
  "askForHelp.email": "Email",
  "askForHelp.submittedHeading": "Your Help Request has been submitted.",
  "askForHelp.submittedDescription":
    "A study representative will respond when available. Response time will vary by location.",
  "askForHelp.nextRequestAvailableToday":
    "Next request available today at {time}",
  "askForHelp.nextRequestAvailableTomorrow":
    "Next request available tomorrow at {time}",
  "askForHelp.requestDisabledTooltip":
    "The study team received your help request and will contact you through your preferred method of communication as soon as possible.",
  "askForHelp.submitRequestError":
    "Sorry, we couldn't submit your request. Please try again.",
  "error.400-message":
    "Your browser sent a request that the server didn't understand. Please go back and try again.",
  "error.400-title": "Bad Request",
  "error.404-message":
    "The page you're looking for no longer exists. Please try again later and contact support if the problem continues.",
  "error.404-title": "Page Not Found",
  "error.410-title": "Page Gone",
  "error.internalServerError": "Internal Server Error",
  "error.internalServerErrorDescription":
    "An error occurred. Please try again later.",
  "error.internalServerErrorRefresh":
    "Sorry, we are having an issue with our servers. Please refresh the page and try again.",
  "error.sessionExpired": "Your Session Is Expired",
  "error.sessionExpiredMessage": "Select OK to return to the login page.",
  "forgotPassword.username": "Username",
  "forgotPassword.usernameRequired": "Username is required",
  "forgotPassword.instructions":
    "Please enter your username to recover your password. You will have to verify your identity with your account's phone and email after this step.",
  "forgotPassword.somethingWentWrong": "Something Went Wrong",
  "forgotPassword.title": "Forgot Password",
  "forgotPassword.emailSentMessage":
    "We've sent an email to the address associated with your username. The link in the email will allow you to reset your password.",
  "forgotPassword.contactSiteMessage":
    "If you don't receive the email or are unable to complete the password reset process, contact your site for an activation code.",
  "inPerson.LAR_GUARDIAN": "Guardian / Representative",
  "inPerson.PARTICIPANT": "Participant",
  "inPerson.PROXY": "Proxy",
  "inPerson.SITE": "Site",
  "inPerson.TRANSLATOR": "Translator",
  "inPerson.WITNESS": "Witness",
  "inPerson.caregiver": "Caregiver",
  "inPerson.allDocumentsHaveBeenSigned": "All documents have been signed",
  "inPerson.begin": "Begin",
  "inPerson.cancel": "Cancel",
  "inPerson.close": "Close",
  "inPerson.help": "Help",
  "inPerson.larGuardian": "Guardian / Representative",
  "inPerson.logBackIn":
    "If you registered an account, you can log in to view your documents.",
  "inPerson.loggedOutOfSiteVault": "We logged you out of {sitevault}.",
  "inPerson.login": "Log In",
  "inPerson.notYetSigned": "Not yet signed",
  "inPerson.participant": "Participant",
  "inPerson.proxy": "Proxy",
  "inPerson.readyToBegin": "Ready to begin?",
  "inPerson.rescanQRCode":
    "Ask your study team to restart your session by scanning the QR code for in-person consent.",
  "inPerson.signed": "Signed",
  "inPerson.site": "Site",
  "inPerson.switchRoleConfirmation":
    "When {nextFirstName} {nextLastName} is ready to review, select Begin to get started.",
  "inPerson.translator": "Translator",
  "inPerson.witness": "Witness",
  "inPerson.reviewTerms": "Review Terms",
  "inPerson.reviewTermsDescription":
    "Please review our Terms of Service and Privacy Notice before continuing.",
  "inPerson.acceptTerms":
    "I accept the {myveevaforpatients} <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Notice</privacyLink>.",
  "inPerson.acceptTermsTitle":
    "I accept the {myveevaforpatients} Terms of Service and Privacy Notice.",
  "inPerson.iAccept": "I Accept",
  "landingScreen.imageAlt": "Person in a clinical trial",
  "login.notEnoughInfo": "Not Enough Login Information",
  "login.notEnoughInfoMessage":
    "You need to add another verification method to access your account. Get an activation code from your study team to add one.",
  "login.accountLocked":
    "Your account is locked from too many attempts. To access your account, select Need Help Logging In or contact your study team.",
  "login.username": "Username",
  "login.usernameTooltip":
    "Try your email address if you don't remember your username.",
  "login.usernameRequired": "Username is required",
  "login.forgotPassword": "Forgot Password?",
  "login.newUser": "New User?",
  "login.registerWithActivationCode": "Register With Activation Code",
  "login.invalidEmail": "Your email must include the at sign (@) and domain.",
  "login.login": "Log In",
  "login.password": "Password",
  "login.passwordRequired": "Password is required",
  "login.passwordEyeTitle": "Show / Hide Password",
  "login.recoverAccount": "Recover Account",
  "login.internalServerError":
    "{myveevaforpatients} is not available. Please try again later.",
  "login.recoverYourAccount": "recover your account",
  "login.incorrectUsernameOrPassword": "Incorrect username or password",
  "login.unableToLogIn": "Unable to Log In",
  "login.fallbackError":
    "We're sorry, logging in is unavailable right now. Please try again.",
  "login.helpLoggingIn": "Need Help Logging In?",
  "login.resetWithCode": "Reset with Activation Code",
  "login.resetWithCodeMessage":
    "If you have forgotten your username, or if you're having other login problems, contact your study team for an activation code.",
  "login.resetEnterCode": "Enter your activation code to reset your login.",
  "newPassword.confirmNewPassword": "Reenter New Password",
  "newPassword.setNewPassword": "Set New Password",
  "newPassword.invalidCode":
    "The link to reset your password expired. You can {requestAnotherEmail} with a new link.",
  "newPassword.linkExpired": "Link Expired",
  "newPassword.linkExpiredMessage":
    "Do you want us to send you a new link to reset your password?",
  "newPassword.returnToLogin": "Return to Login",
  "newPassword.openLinkError": "Unable to Open Link",
  "newPassword.openLinkErrorMessage":
    "Sorry, we were unable to open that link. Please reselect the link we sent you, or contact your study site for help.",
  "newPassword.login": "log in",
  "newPassword.newPassword": "New Password",
  "newPassword.passwordUpdated": "Password Updated",
  "newPassword.requestAnotherEmail": "request another email",
  "newPassword.submit": "Change Password and Continue",
  "newPassword.success":
    "You successfully updated your password and you're ready to {login}.",
  "newPassword.title": "Change Password",
  "newPassword.notEnoughInfo": "Not Enough Information",
  "newPassword.notEnoughInfoMessage":
    "You need a phone number on your account to reset your password by yourself. Get an activation code from your study team to reset your password and update your account.",
  "notifications.clearAll": "Clear All",
  "notifications.clearNotification": "Clear Notification",
  "notifications.confirmClearAll": "Confirm Clear All",
  "notifications.couldNotClear": "Notifications Could Not Be Cleared",
  "notifications.couldNotClearRefresh":
    "Sorry, we were not able to clear the notifications. Please refresh the page to try again.",
  "notifications.new": "New",
  "notifications.noNotifications": "No Notifications",
  "notifications.notifications": "Notifications",
  "notifications.pleaseLoginToContinue": "Please log in to continue.",
  "notifications.readLess": "Read Less",
  "notifications.readMore": "Read More",
  "notifications.today": "Today",
  "notifications.upToDate": "You're all up to date",
  "notifications.yesterday": "Yesterday",
  "register.activationCode": "Activation Code",
  "register.addEmail": "Add Email",
  "register.addEmailDescription":
    "We'll send you an email to verify this address.",
  "register.addPhone": "Add Phone",
  "register.addPhoneDescription":
    "We'll send you a code to verify this number. You can get the code by text message or phone call.",
  "register.addVerificationMethod": "Add Verification Method",
  "register.addVerificationMethodDescription":
    "Add an email or a phone number to your account. This information is required to verify your identity the next time you log in.",
  "register.codeOnlyMobileApp": "Code Only for Mobile App",
  "register.codeOnlyMobileAppError":
    "You can only use this code in the {myveevaforpatients} mobile application. Download the mobile app and enter the activation code on the login page to register.",
  "register.confirmIdentityHeadingCall": "Confirm Identity – Voice Call",
  "register.confirmIdentityHeadingEmail": "Confirm Identity – Email",
  "register.confirmIdentityHeadingText": "Confirm Identity – Text",
  "register.confirmIdentityHeadingDescriptionCall":
    "We're calling <span>{phone}</span> to give you a six-digit verification code. Enter it below.",
  "register.confirmIdentityHeadingDescriptionEmail":
    "We sent an email to <span>{email}</span> with a link that will allow you to log in.",
  "register.confirmIdentityHeadingDescriptionText":
    "We sent a text with a six-digit verification code to <span>{phone}</span>. Enter it below.",
  "register.didntReceiveCode": "Didn't receive the code?",
  "register.didntReceiveEmail": "Didn't receive the email?",
  "register.email": "Email",
  "register.emailInvalid": "Email must include the at sign (@) and domain.",
  "register.emailRequired": "Email is required",
  "register.emailSubmitError":
    "Invalid email. Check the email address and try again.",
  "register.enterActivationCodeTitle": "Enter Activation Code",
  "register.enterActivationCodeDescription":
    "Enter the activation code you received from your study team. Contact your study team if you need an activation code.",
  "register.getAText": "Get a Text",
  "register.getAnotherCall": "Get Another Call",
  "register.invalidActivationCode": "Invalid activation code",
  "register.invalidActivationCodeTitle": "Invalid Activation Code",
  "register.invalidActivationCodeDescription":
    "If you're having trouble with the code, contact your study team for help.",
  "register.invalidVerificationCode": "Invalid Verification Code",
  "register.next": "Next",
  "register.password": "Password",
  "register.passwordMustContainLowerCase": "Must have a lowercase letter",
  "register.passwordMustContainNumber": "Must have a number",
  "register.passwordMustContainOneSpecialCharacter":
    "Must have a special character",
  "register.passwordMustContainUpperCase": "Must have an uppercase letter",
  "register.passwordLengthInvalid": "Must be 8-25 characters long",
  "register.passwordsDoNotMatch": "Passwords must match",
  "register.phoneNumber": "Phone Number",
  "register.receiveACall": "Receive a Call",
  "register.reenterPassword": "Reenter Password",
  "register.sendAnotherCode": "Send Another Code",
  "register.sendAnotherEmail": "Send Another Email",
  "register.sendEmail": "Send Email",
  "register.sent": "Sent ({time}s)",
  "register.setPassword": "Set Password",
  "register.setUsername": "Set Username",
  "register.acceptTermsTitle":
    "I accept the {myveevaforpatients} Terms of Service and Privacy Notice.",
  "register.acceptTerms":
    "I accept the {myveevaforpatients} <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Notice</privacyLink>.",
  "register.setUsernameDescription":
    "Usernames can contain letters, numbers, and the following special characters: . @ + - _",
  "register.somethingWentWrong": "Something Went Wrong",
  "register.somethingWentWrongTitle": "Something Went Wrong",
  "register.somethingWentWrongDescription": "Please try again.",
  "register.tooManyRequests": "Too Many Requests",
  "register.tooManyRequestsMessage":
    "We can't send another code to this number right now. Check the number and try again in 10 minutes.",
  "register.tryAgainDescriptionCall":
    "Make sure your device has a signal and request another code.",
  "register.tryAgainDescriptionText":
    "Make sure your device has a network connection. If you still don't receive the code, request another code, or go back and try another method.",
  "register.tryAgainDescriptionEmail":
    "Check your spam folder for an email from {myveeva}. If you didn't receive it, send another email.",
  "register.unableToSendCode": "Unable to Send Code",
  "register.unableToSendCodeMessage":
    "Sorry, we couldn't send your verification code. Check the number and try again.",
  "register.unableToSendText": "Unable to Send Text",
  "register.unableToSendTextMessage":
    "This number can't receive texts. Request a call to receive the code at this number.",
  "register.username": "Username",
  "register.usernameAlreadyTaken":
    "Username is already in use. Try a different username, or log in if you already have an account.",
  "register.usernameCantBeginWithSpecialCharacter":
    "Username can't begin with a special character.",
  "register.usernameHasWhitespace":
    "Username can't contain spaces. Remove the spaces and try again.",
  "register.usernameInvalid": "Invalid username",
  "register.usernameRequired": "Username is required",
  "register.enterYob": "Enter Year of Birth",
  "register.yobMessage": "To confirm your identity, enter your year of birth.",
  "register.yearOfBirth": "Year of Birth",
  "register.yobError":
    "Year of birth does not match what is on file for this study. Try entering the correct year again.",
  "register.yobInvalid": "Invalid year",
  "register.yobMaxAttemptsTitle": "Maximum Attempts",
  "register.yobMaxAttemptsMessage":
    "Your study team may have entered your year of birth incorrectly. Contact them to get a new activation code and try again.",
  "register.yobYearPlaceholder": "YYYY",
  "registerEmail.email": "Email",
  "smartBanner.continueInBrowser": "Continue in Browser",
  "smartBanner.downloadTheMyVeevaApp": "Download the {myveeva} app",
  "smartBanner.getTheApp": "Get the App",
  "textField.editLabel": "Edit {label}",
  "viewerBackButton.backButtonTooltip": "Back to list",
  "patientViewerError.loggedOut": "Logged Out",
  "patientViewerError.loggedOutWhileInactive":
    "We logged you out while you were inactive. Please select OK to log in again.",
  "patientViewerError.surveyNoLongerAvailable": "Survey No Longer Available",
  "patientViewerError.surveyNoLongerAvailableMessage":
    "You already submitted this survey or it's no longer available. Go back to view your remaining tasks.",
  "patientViewerError.surveyStartErrorTitle": "Survey Could Not Be Started",
  "patientViewerError.surveyStartErrorMessage":
    "Another survey must be completed before starting this survey. To start the other survey, select <b>Start.</b>",
  "patientViewerError.cancel": "Cancel",
  "patientViewerError.start": "Start",
  "patientViewerError.websiteIssues": "Website Issues",
  "patientViewerError.websiteIssuesMessage":
    "Sorry, we are having an issue with our website servers. Please refresh the page and try again.",
  "diary.surveyCompleted": "Survey Completed",
  "diary.multipleStatuses": "Multiple Statuses",
}
